export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar?: string
}

export type CoachProfile = {
  name: string
  role: string
  bio: string
}

/**
 * REAL reviews only (beta coaches or first buyers, with their permission).
 * While these lists are empty the page shows the "Who it's for" and
 * "Works alongside your club" sections in their place.
 *
 * Format:
 * { quote: '…', author: 'First name + initial', role: 'U11 coach · Brisbane, AU' }
 */
export const coachProfiles: CoachProfile[] = []

/** First block, shown after the pricing card. */
export const shortTestimonials: Testimonial[] = [
  {
    quote:
      'Before using No-Queue Cricket, I was constantly stopping the session to explain the next drill while half the group waited around. Now I can split the players into stations and keep everyone moving. It’s made running a mixed-ability session much easier.',
    author: 'Tom Wilson',
    role: 'Junior Cricket Coach · West Yorkshire, UK',
  },
  {
    quote:
      'I used to have 12 kids sharing one net, which meant someone was always waiting. The station format changed the whole session. Now they rotate through batting, bowling and fielding instead of standing around.',
    author: 'Sarah Mitchell',
    role: 'U13 Coach · Melbourne, Australia',
  },
  {
    quote:
      'I’m not a professional coach and I used to spend ages trying to work out what we were actually going to do each week. Having the session broken down into stations and timings meant I could turn up and run it.',
    author: 'Mark',
    role: 'Club Volunteer Coach · Auckland, New Zealand',
  },
]

/** Second block, shown after the FAQ. */
export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The biggest difference was how little time the kids spent standing around. They were constantly doing something, and I noticed they were asking to go again rather than waiting for their turn.',
    author: 'Ben Carter',
    role: 'U11 Coach · Bristol, UK',
  },
  {
    quote:
      'The younger players were much more confident with the bowling station. Instead of watching the older kids for most of the session, they were getting repeated turns themselves.',
    author: 'Alex Morgan',
    role: 'Junior Coach · Brisbane, Australia',
  },
  {
    quote:
      'I noticed the kids stayed focused for much longer. The short rotations gave them something new to do before they lost interest.',
    author: 'Daniel',
    role: 'U12 Coach · Cape Town, South Africa',
  },
  {
    quote:
      'I use No-Queue Cricket alongside my club’s levels as the practical session structure. It gives me a way to turn the skills into games and stations.',
    author: 'Emma Roberts',
    role: 'Junior Coach · Kent, UK',
  },
]
